import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@tempmee/react';

/**
 * The compact title for a `TableCardFrame` inside a profile tab. TableCard's
 * default string title is 18px bold, which reads too heavy there; subtitle2
 * keeps it a clear notch above the table's column headers without competing
 * with the page.
 */
export const TableCardTitle = ({ children }) => (
  <Typography variant="subtitle2" as="h2" bold className="truncate text-text-primary">
    {children}
  </Typography>
);

TableCardTitle.propTypes = {
  children: PropTypes.node.isRequired,
};
